import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="toggle-fields"
export default class extends Controller {
  static targets = ["source", "field"]
  static values = {
    showWhen: Object  // Maps source values to target names that should be visible
  }

  connect() {
    this.toggle()
  }

  toggle() {
    const sourceValue = this.sourceTarget.value

    // Hide all fields first
    this.fieldTargets.forEach(field => {
      field.classList.add("hidden")
    })

    // Get the targets that should be shown for this value
    const targetsToShow = this.showWhenValue[sourceValue] || []
    
    // Show only the relevant fields
    this.fieldTargets.forEach(field => {
      const targetName = field.dataset.toggleFieldsTargetName
      if (targetsToShow.includes(targetName)) {
        field.classList.remove("hidden")
      }
    })
  }
}
